import { render, staticRenderFns } from "./CreateEditSubCategory.vue?vue&type=template&id=1773e296&scoped=true&"
import script from "./CreateEditSubCategory.vue?vue&type=script&lang=js&"
export * from "./CreateEditSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773e296",
  null
  
)

export default component.exports